import {cn} from '@sollapay/ui';
import {Dot, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface AssetTrustProgressLegendProps {
  depositPaidFormatted: string;
  amountToPayFormatted: string;
  className?: string;
}

export const AssetTrustProgressLegend: FC<AssetTrustProgressLegendProps> = ({
  depositPaidFormatted,
  amountToPayFormatted,
  className
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div data-slot="legend" className={cn('flex items-center gap-6', className)}>
      <LegendItem
        dotColorClassName="bg-progress-fill"
        hasDotRing
        label={t('view.buyers.list.summary.depositedInTrust')}
        value={depositPaidFormatted}
      />
      <LegendItem
        dotColorClassName="bg-fg-disabled/50"
        label={t('view.buyers.list.summary.remainingToPay')}
        value={amountToPayFormatted}
      />
    </div>
  );
};

interface LegendItemProps {
  dotColorClassName: string;
  hasDotRing?: boolean;
  label: string;
  value: string;
}

const LegendItem: FC<LegendItemProps> = ({dotColorClassName, hasDotRing, label, value}) => (
  <div className="flex items-center gap-2">
    <Dot colorClassName={dotColorClassName} ring={hasDotRing} />
    <Typography as="span" size="xs" color="tertiary">
      {label}
    </Typography>
    <Typography as="span" size="sm" weight="semibold" className="tabular-nums">
      {value}
    </Typography>
  </div>
);
